import React, { useState } from 'react';
import { PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { formatBrowser } from '../utils/dateUtils';

function DevicePanel({ device, selected, open, onToggle, onSelect, onShowInfo, flyToDevice }) {
  const [hovered, setHovered] = useState(false);

  const blueKunak = '#0075C9';
  const bgHover = '#f0f7fa';
  const bgSelected = '#e6f4fb';

  const rowBg = selected ? bgSelected : hovered ? bgHover : '#fff';
  const expandedBg = selected ? bgSelected : '#fff';

  const handleClick = () => {
    if (selected) {
      onShowInfo(null);
      onSelect(null); // limpia la selección global (Dashboard)
      if (open) onToggle(device.id);
    } else {
      onShowInfo(device);
      if (!open) onToggle(device.id);
      if (flyToDevice) flyToDevice(device); // asegura siempre centrar
      if (onSelect) onSelect(device);
    }
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          cursor: 'pointer',
          padding: '5px 17px 5px 10px',
          userSelect: 'none',
          background: rowBg,
          // borderRadius: 5,
          transition: 'background 0.2s',
          borderLeft: selected ? '4px solid #0075C9' : '4px solid transparent',
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={handleClick}
      >
        <span
          style={{
            color: hovered || selected ? blueKunak : undefined,
            fontWeight: selected ? 600 : 400,
            background: 'transparent',
            transition: 'color 0.2s',
            borderRadius: 4,
            padding: '2px 4px',
          }}
        >
          {device.name}
        </span>
        <span
          onClick={e => {
            e.stopPropagation();
            onToggle(device.id);
          }}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          {open ? (
            <MinusCircleOutlined style={{ fontSize: 14 }} title="Hide details" />
          ) : (
            <PlusCircleOutlined style={{ fontSize: 14 }} title="Show details" />
          )}
        </span>
      </div>
      {open && (
        <div style={{ padding: '0px 24px 16px 24px', background: expandedBg, borderLeft: selected ? '4px solid #0075C9' : '4px solid transparent' }}>
          <Space direction="vertical" size="small" style={{ width: '100%', fontSize: 13 }}>
            <div>SN: {device.serialNumber || '-'}</div>
            <div>Type: {device.entityType?.name || '-'}</div>
            <div>Last read: {device.lastReadDate ? formatBrowser(device.lastReadDate, { seconds: true }) : '-'}</div>
          </Space>
        </div>
      )}
    </div>
  );
}

export default DevicePanel;
